var vivagoApp = (function() {

	var app = {
		dom: {
			$win: $(window),
			$doc: $(document),
			$body: $('body'),
			breakpoints: {
				xs : 100,
				sm : 100,
				md : 100,
				lg : 100,
			}
		}
	};

	app.slick = (function() {

		var SLICK_DIRECTION_NEXT = 'NEXT';
		var SLICK_DIRECTION_PREV = 'PREV';
		var SLICK_ITEM_ANIMATION_CLASS = 'solutions__item--faded';
		var SLICK_ARROW_PREV = 'solutions__button--prev';
		var SLICK_ARROW_NEXT = 'solutions__button--next';

		var slickGetDirection = function(current, next) {
			return current > next ? SLICK_DIRECTION_PREV : SLICK_DIRECTION_NEXT;
		}

		var init = function () {

			$('.solutions__slider').on('afterChange', function(event, slick, currentSlide){
			 	$('.' + SLICK_ITEM_ANIMATION_CLASS).removeClass(SLICK_ITEM_ANIMATION_CLASS);
			});

			$('.solutions__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var direction = slickGetDirection(currentSlide, nextSlide);
				if (direction == SLICK_DIRECTION_NEXT) {
					$('.solutions__item.slick-active:last()').next().addClass(SLICK_ITEM_ANIMATION_CLASS);
				} else {
					$('.solutions__item.slick-active:first()').prev().addClass(SLICK_ITEM_ANIMATION_CLASS);
				}
			});

			$('.solutions__slider').slick({
				infinite: false,
				draggable : false,
				swipe : false,
				waitForAnimate : true,
				slidesToShow : 5,
				slidesToScroll : 1,
				centerMode : false,
				prevArrow : '.solutions__button--prev',
				nextArrow : '.solutions__button--next',
				responsive: [
					{
					  breakpoint: 2048,
					  settings: {
					    slidesToShow: 4,
					    slidesToScroll: 1
					  }
					},		
					{
					  breakpoint: 1240,
					  settings: {
					    slidesToShow: 3,
					    slidesToScroll: 1
					  }
					},		
					{
					  breakpoint: 960,
					  settings: {
					    slidesToShow: 2,
					    slidesToScroll: 1
					  }
					},		
					{
					  breakpoint: 680,
					  settings: {
					    slidesToShow: 1,
					    slidesToScroll: 1
					  }
					}
				]
			});

		};

		return {
			init: init
		};

	})();

	app.faq = (function() {

		var init = function() {

			/**
			 * FAQ item collapse
			 */
			$('.faq .panel-title a').click(function() {

				if ($(this).find('.icon-container.minus').length > 0) {
					$(this).find('.icon-container.minus').toggleClass('plus').toggleClass('minus');
				} else {
					$.merge($('.icon-container.minus'),$(this).find('.icon-container')).toggleClass('plus').toggleClass('minus');	
				}

			});

		}

		return {
			init : init
		}

	})();

	app.navigation = (function() {

		var hideLang = function() {
			$('.header__lang-options-wrapper').removeClass('header__lang-options-wrapper--active');
			$('.header__lang-wrapper').removeClass('header__lang-wrapper--active');
		}
		var hideSearch = function() {
			$('.header__search-wrapper').collapse('hide')
		}
		var updateNavigation = function() {
			if (app.dom.$win.width() >= 992) {
				if ( !$('header nav').hasClass('navbar-fixed-top') ) {
					$('header nav').addClass('navbar-fixed-top');
					$('body').removeClass('navigation-static');
				}
			} else {
				if ( $('header nav').hasClass('navbar-fixed-top') ) {
					$('header nav').removeClass('navbar-fixed-top');
					$('body').addClass('navigation-static');
				}
			}
		}

		var init = function() {

			/**
			 * Change navigation to fixed top if desktop. If mobile switch to static top.
			 */
			updateNavigation();
			$(window).on('resize', function(){
				updateNavigation();
			});

			/**
			 * Opens dropdowns by hover or click based on window width.
			 */
			if ($(window).width() > 1200) {
				$(".header ul.navbar-nav>li.dropdown").hover(function() {
					$(this).addClass("open");
				}, function() {
					$(this).removeClass("open");
				});
			} else {
				$(".header ul.navbar-nav li.dropdown .toggle-dropdown").click(function(e) {
					e.preventDefault();
					$(this).parent().toggleClass("open");
					$(this).children().toggleClass("show");
				});
			}

			$('.header__lang-wrapper').click( function() {
				$('.header__lang-options-wrapper').toggleClass('header__lang-options-wrapper--active');
				$('.header__lang-wrapper').toggleClass('header__lang-wrapper--active');
				hideSearch();
			});

			/**
			 * Focus to search input when search icon clicked
			 */
			$('.header__search-wrapper').on('shown.bs.collapse', function() {
			  	$('.header__search-form input[type="search"]').focus();
			});

			/**
			 * Hide language and search when scrolled
			 */
			$(app.dom.$win).scroll(function() {
				hideLang();
				hideSearch();
			});

			/**
			 * Hide language when search is shown.
			 */
			$('.header__search-wrapper').on('show.bs.collapse', function (e) {
				hideLang();
			});

		}

		return {
			init : init
		}

	})();	

	app.news = (function() {

		var init = function() {

			$('.news-list__show').click(function() {
				$(this).children().toggle();
				$(this).parents('.news-list').toggleClass('news-list--expand');
				$('.news-list ul li:nth-child(n+11)').toggleClass('news-list__item--hidden');
			});

		}

		return {
			init : init
		}

	})();	

	app.carousel = (function() {

		var createCarousel = function(carouselSelector, attributes) {
			$(carouselSelector).slick(attributes);
		}

		var init = function() {

			if ( $('.carousel__carousel--retailers').length > 0 ) {
				createCarousel( '.carousel__carousel--retailers', {
					infinite: false,
					draggable : false,
					swipe : false,
					waitForAnimate : true,
					slidesToShow : 2,
					slidesToScroll : 1,
					centerMode : false,
					prevArrow : '.carousel__button--retailers.carousel__button--prev',
					nextArrow : '.carousel__button--retailers.carousel__button--next',
					responsive: [
						{
						  breakpoint: 2048,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 1240,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 960,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 680,
						  settings: {
						    slidesToShow: 1,
						    slidesToScroll: 1
						  }
						}
					]
				});
			}		
			if ( $('.carousel__carousel--products').length > 0 ) {
				createCarousel( '.carousel__carousel--products', {
					infinite: false,
					draggable : false,
					swipe : false,
					waitForAnimate : true,
					slidesToShow : 2,
					slidesToScroll : 1,
					centerMode : false,
					prevArrow : '.carousel__button--products.carousel__button--prev',
					nextArrow : '.carousel__button--products.carousel__button--next',
					responsive: [
						{
						  breakpoint: 2048,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 1240,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 960,
						  settings: {
						    slidesToShow: 2,
						    slidesToScroll: 1
						  }
						},		
						{
						  breakpoint: 680,
						  settings: {
						    slidesToShow: 1,
						    slidesToScroll: 1
						  }
						}
					]
				});	
			}
		}

		return {
			init : init
		}

	})();	

	app.blog = (function() {

		var CLASS_SHARE_BOTTOM = 'blog-post__share--bottom';
		var CLASS_SHARE_BUTTON_BOTTOM = 'blog-post__share-button--bottom';
		var fullscreen = true;
		var userAgent = window.navigator.userAgent;
		var ios = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);

		var relocateShare = function($top,$share,$content,$nav,$footer,$shareButtons,$post) {
			if (
				(($top.offset().top + $top.height() + $share.height()) - $win.scrollTop() - $nav.height() > 0 && $win.width() >= 992) ||
				(($top.offset().top + $top.height() + $share.height()) - $win.scrollTop() > 0 && $win.width() < 992)
				) {
				if ($share.hasClass(CLASS_SHARE_BOTTOM)) {
					$share.removeClass(CLASS_SHARE_BOTTOM);
					$shareButtons.removeClass(CLASS_SHARE_BUTTON_BOTTOM);
					$share.css('width','auto');
					$share.css('bottom',0);
					$share.css('left','auto');
					$post.css('margin-bottom',0);
				}
			} else {
				if (!$share.hasClass(CLASS_SHARE_BOTTOM)) {
					$share.addClass(CLASS_SHARE_BOTTOM);
					$shareButtons.addClass(CLASS_SHARE_BUTTON_BOTTOM);
				}
				$post.css('margin-bottom', $share.height() + 'px');
				$share.css('width',$content.width() + 'px');
				var shareBottom = $win.height() + $win.scrollTop() - $footer.offset().top;
				// Ugly hack for iOS Safari fullscreen.
				if (ios && !fullscreen) {
					shareBottom += $share.height() + 10;
				}
				if (shareBottom > 0) {
					$share.css('bottom',shareBottom);					
				} else {
					$share.css('bottom', 0);					
				}

				$share.css('left',$content.offset().left);
			}
		}

		var init = function() {
			$win = $(window);
			$post = $('.blog-post');
			$content = $('.blog-post__content');
			$top = $('.blog-post__top');
			$share = $('.blog-post__share');
			$shareButtons = $('.blog-post__share-button');
			$nav = $('header .navbar');
			$footer = $('footer');
			relocateShare($top,$share,$content,$nav,$footer,$shareButtons,$post);
			$win.scroll(function() {
				relocateShare($top,$share,$content,$nav,$footer,$shareButtons,$post);
			});			
			$win.resize(function() {
				relocateShare($top,$share,$content,$nav,$footer,$shareButtons,$post);
			});
			$(document,window).on('resize orientationchange webkitfullscreenchange mozfullscreenchange fullscreenchange',  function(){
				fullscreen = !fullscreen;
				relocateShare($top,$share,$content,$nav,$footer,$shareButtons,$post);
			});
		}

		return {
			init:init
		}

	})();	

	app.dom.$doc.ready(function() {
		contactUsForm.init();
		if ( $('.solutions__slider').length > 0 ) app.slick.init();
		if ( $('.faq').length > 0 ) app.faq.init();
		if ( $('.news-list').length > 0 ) app.news.init();
		if ( $('.carousel').length > 0 ) app.carousel.init();
		if ( $('.header .nav').length > 0 ) app.navigation.init();		
		if ( $('.blog-post').length > 0 ) app.blog.init();
	});

	return app;

})();
